import React, { Component } from 'react'
import { Box, FormControl, MenuItem, Select, TextField } from '@mui/material'
import { FormInputLabel } from '@/shared/ui/input'
import DualModeEditor from '@/feature/admin/editor/DualModeEditor'

class DefDossierDefFieldCalcSettings extends Component {
    constructor(props) {
        super(props)
        this.state = {
            formula: this.props.item?.settings?.formula ?? '',
            output: this.props.item?.settings?.output ?? 'text',
            format: this.props.item?.settings?.format ?? '',
            unit: this.props.item?.settings?.unit ?? '',
            unitPosition: this.props.item?.settings?.unit_position ?? 'after',
            decimalPlaces: this.props.item?.settings?.decimal_places ?? 2,
            ratingMax: this.props.item?.settings?.rating_max ?? 5,
        }
        this.handleFormulaChange = this.handleFormulaChange.bind(this)
        this.handleSettingChange = this.handleSettingChange.bind(this)
    }

    handleFormulaChange(value) {
        this.setState({ formula: value })
        setTimeout(() => this.props.onChange('formula', value), 50)
    }

    handleSettingChange(stateKey, settingKey, value) {
        this.setState({ [stateKey]: value })
        this.props.onChange(settingKey, value)
    }

    handleOutputChange(value) {
        this.handleSettingChange('output', 'output', value)
    }

    renderDecimalFormatSettings() {
        const { kedo } = this.props
        const { format, unit, unitPosition, decimalPlaces, ratingMax } =
            this.state

        return (
            <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
                <FormControl fullWidth margin="dense">
                    <FormInputLabel htmlFor="format-select">
                        {kedo.t('Format')}
                    </FormInputLabel>
                    <Select
                        inputProps={{ id: 'format-select' }}
                        size="small"
                        name="format"
                        value={format}
                        displayEmpty
                        onChange={(e) =>
                            this.handleSettingChange(
                                'format',
                                'format',
                                e.target.value
                            )
                        }
                    >
                        <MenuItem value="">
                            {kedo.t('Choose an option')}
                        </MenuItem>
                        <MenuItem value="number">{kedo.t('Number')}</MenuItem>
                        <MenuItem value="currency">
                            {kedo.t('Currency')}
                        </MenuItem>
                        <MenuItem value="percentage">
                            {kedo.t('Percentage')}
                        </MenuItem>
                        <MenuItem value="measurement">
                            {kedo.t('Measurement')}
                        </MenuItem>
                        <MenuItem value="rating">{kedo.t('Rating')}</MenuItem>
                    </Select>
                </FormControl>

                {['number', 'percentage', 'measurement'].includes(format) && (
                    <TextField
                        label={kedo.t('Decimal places')}
                        type="number"
                        size="small"
                        value={decimalPlaces}
                        onChange={(e) =>
                            this.handleSettingChange(
                                'decimalPlaces',
                                'decimal_places',
                                Number(e.target.value)
                            )
                        }
                        inputProps={{ min: 0, max: 8 }}
                        fullWidth
                    />
                )}

                {format === 'measurement' && (
                    <>
                        <TextField
                            label={kedo.t('Unit')}
                            size="small"
                            value={unit}
                            onChange={(e) =>
                                this.handleSettingChange(
                                    'unit',
                                    'unit',
                                    e.target.value
                                )
                            }
                            fullWidth
                        />
                        <FormControl fullWidth margin="dense">
                            <FormInputLabel htmlFor="unit-position-select">
                                {kedo.t('Unit position')}
                            </FormInputLabel>
                            <Select
                                inputProps={{ id: 'unit-position-select' }}
                                size="small"
                                name="unit_position"
                                value={unitPosition}
                                onChange={(e) =>
                                    this.handleSettingChange(
                                        'unitPosition',
                                        'unit_position',
                                        e.target.value
                                    )
                                }
                            >
                                <MenuItem value="before">
                                    {kedo.t('Before')}
                                </MenuItem>
                                <MenuItem value="after">
                                    {kedo.t('After')}
                                </MenuItem>
                            </Select>
                        </FormControl>
                    </>
                )}

                {format === 'rating' && (
                    <TextField
                        label={kedo.t('Maximum rating')}
                        type="number"
                        size="small"
                        value={ratingMax}
                        onChange={(e) =>
                            this.handleSettingChange(
                                'ratingMax',
                                'rating_max',
                                Number(e.target.value)
                            )
                        }
                        inputProps={{ min: 1, max: 10 }}
                        fullWidth
                    />
                )}
            </Box>
        )
    }

    render() {
        const { kedo } = this.props
        const { formula, output } = this.state
        return (
            <div>
                <h5>{this.props.kedo.t('Additional settings')}</h5>
                <FormControl fullWidth margin="dense">
                    <FormInputLabel htmlFor="output-label">
                        {kedo.t('Output')}
                    </FormInputLabel>
                    <Select
                        inputProps={{ id: 'output-label' }}
                        size="small"
                        name="output"
                        value={output}
                        displayEmpty
                        onChange={(e) => {
                            this.handleOutputChange(e.target.value)
                        }}
                    >
                        <MenuItem value="text">{kedo.t('Text')}</MenuItem>
                        <MenuItem value="date">{kedo.t('Date')}</MenuItem>
                        <MenuItem value="datetime">
                            {kedo.t('Datetime')}
                        </MenuItem>
                        <MenuItem value="integer">{kedo.t('Integer')}</MenuItem>
                        <MenuItem value="decimal">{kedo.t('Decimal')}</MenuItem>
                    </Select>
                </FormControl>
                {output === 'decimal' && this.renderDecimalFormatSettings()}
                <FormControl fullWidth margin="normal">
                    <DualModeEditor
                        value={formula}
                        onChange={this.handleFormulaChange}
                        kedo={kedo}
                        language="kedoexpr"
                        originEntity={this.props.defDossier}
                        label={kedo.t('Formula')}
                        togglePlacement="bottom"
                    />
                </FormControl>
            </div>
        )
    }
}

export default DefDossierDefFieldCalcSettings
